import { render, staticRenderFns } from "./claimListV2.vue?vue&type=template&id=69268351&scoped=true"
import script from "./claimListV2.vue?vue&type=script&lang=js"
export * from "./claimListV2.vue?vue&type=script&lang=js"
import style0 from "./claimListV2.vue?vue&type=style&index=0&id=69268351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69268351",
  null
  
)

export default component.exports